import cpuIcon from '@iconify/icons-feather/cpu';
import { InlineIcon } from '@iconify/react';
import { useCallback } from 'react';
import { StyledIconButton } from '../listing-info-title-styles';

interface Props {
  currentCity: string;
  isAdmin: boolean;
  listingDeckardID: string;
}

export function CyborgButton(props: Props) {
  const goToCyborg = useCallback(() => {
    if (props.isAdmin) {
      /**
       * This is for admin use only.
       * Split the "currentCity" value to be able to get the parts of the URL for the Cyborg URL
       *  1. State - 2 letter state abbreviation capitalized
       *  2. County - underscored
       *  3. City - underscored, if in a county then replace with an underscore
       */
      const [state, county, city = '_'] = props.currentCity.split('-');
      window.open(
        `https://cyborg.deckard.com/listing/${state.toUpperCase()}/${county}/${city}/${
          props.listingDeckardID
        }`,
        '_blank'
      );
    }
  }, [props.currentCity, props.listingDeckardID, props.isAdmin]);

  if (!props.isAdmin) return null;

  return (
    <StyledIconButton
      aria-label="Open listing in Cyborg"
      disabled={!props.isAdmin}
      size="sm"
      icon={<InlineIcon aria-hidden icon={cpuIcon} className="rs-icon" />}
      placement="left"
      onClick={goToCyborg}
    />
  );
}
